import { defineStore } from 'pinia';

import { pinia } from './store.js';

// Итоги одного собеса: разбор, оценки, вопросы с эталонами, стенограмма,
// запись. Всё это данные — значит, по умолчанию они здесь.
//
// В компоненте остаются только ручки: плеер, таймер дозагрузки хвоста, «пишу
// эталон прямо сейчас». Они не переживают уход со страницы и не должны.

export const useSession = defineStore('session', {
  state: () => ({
    id: null,
    info: null,          // сама сессия: формат, статус, длительность
    project: null,
    feedback: '',
    scores: [],
    points: [],
    plan: [],
    turns: [],
    questions: [],
    references: {},
    metrics: null,
    marks: [],
    цена: null,
    заНеделю: null,
    hasAudio: false,
    // Какая вкладка открыта, читается ли «правда» инцидента, ждём ли хвост —
    // это тоже состояние страницы, и возвращаться на неё лучше туда же, где
    // ушёл.
    tab: 'report',
    showTruth: false,
    tailPending: false,
    loading: true,
    error: '',
  }),
  actions: {
    /**
     * Открываем другой собес — забываем прошлый.
     *
     * Иначе на долю секунды видно чужой разбор, чужие оценки и чужую
     * стенограмму, а плеер успевает попросить запись, которой на этой
     * странице нет.
     */
    open(id) {
      if (this.id === id) return;
      this.id = id;
      this.info = null;
      this.project = null;
      this.feedback = '';
      this.scores = [];
      this.points = [];
      this.plan = [];
      this.turns = [];
      this.questions = [];
      this.references = {};
      this.metrics = null;
      this.marks = [];
      this.hasAudio = false;
      this.showTruth = false;
      this.tailPending = false;
      this.loading = true;
      this.error = '';
    },

    /** Разложить ответ ручки отчёта. Одно место — одна форма данных. */
    take(data) {
      this.info = data.session;
      this.project = data.project;
      this.feedback = data.feedback;
      this.scores = data.scores;
      this.points = data.points;
      this.plan = data.plan || [];
      this.metrics = data.metrics || null;
      this.questions = data.questions || [];
      this.references = Object.fromEntries(
        (data.references || []).map((r) => [r.question_id, r.body]));
      this.turns = data.turns;
      this.hasAudio = data.has_audio;
      this.marks = data.marks || [];
      // Цена собеса и недельный итог: смотрят их там же, где решают, проводить
      // ли следующий.
      this.цена = data.цена || null;
      this.заНеделю = data.за_неделю || null;
    },
  },
});

export const session = useSession(pinia);
